import styled from "styled-components";
import defaultImg from "../images/background6.jpg";

const StyledHero = styled.header`
  min-height: 45vh;
  background: url(${(props) => (props.image ? props.image : defaultImg)})
    center/cover no-repeat;
  align-items: left;
  justify-content: center;
  display: flex;
  flex-direction: column;
  margin: 0;

  h3 {
    color: #302d2d;
    font-size: 2.2rem;
    margin: 10px 0;
    margin-left: 50px;
  }
  p,
  p a {
    color: #e23535;
    margin-left: 50px;
    font-size: 1.2rem;
    cursor: pointer;
  }

  p a {
    text-decoration: none;
    margin-left: initial;
  }

  @media screen and (max-width: 768px) {
    min-height: 30vh;
    h3 {
      font-size: 1.8rem;
    }
    p,
    p a {
      font-size: 1.1rem;
    }
  }

  @media screen and (max-width: 450px) {
    h3 {
      font-size: 1.4rem;
      margin-left: 20px;
    }
    p {
      margin-left: 20px;
    }
  }
`;

export { StyledHero };
